<template>
  <div>
    <v-tabs
    v-model="tab"
      background-color="deep-purple accent-4"
      centered
      dark
      icons-and-text
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">
        Listado Pagos
      </v-tab>

      <v-tab href="#tab-2">
        Agregar Pago
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text>
            <ListarAbonosVue />
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item value="tab-2">
        <v-card>
          <CrearEditarAbonoVue />
        </v-card>
      </v-tab-item>

    </v-tabs-items>
</div>
</template>
<script>
import CrearEditarAbonoVue from './CrearEditarAbono.vue'

import ListarAbonosVue from './ListarAbonos.vue'

  export default {
    name:"TabAbonos",
    components:{ListarAbonosVue,CrearEditarAbonoVue},
    data () {
      return {
        tab: null,
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      }
    }
  }
</script>